import { Box, 
  // IconButton,  MenuItem,
   Typography } from "@mui/material";
import { useEffect, useState } from "react";
// import { BsThreeDots } from "react-icons/bs";
import { useNavigate, useParams } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import UserProject from "./PortalUsersDetail/UserProject";
import UserTask from "./PortalUsersDetail/UserTask";
import UserIssue from "./PortalUsersDetail/UserIssue";
import UserActivity from "./PortalUsersDetail/UserActivity";
import UserMilestone from "./PortalUsersDetail/UserMilestone";
import UserOverview from "./PortalUsersDetail/UserOverview";
import { fetchEntityById } from "../../apis/apiService";
import UserTimeSheetTab from "./PortalUsersDetail/UserTimesheet";
import Loader from "../../components/common/Loader";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { MdCalendarToday, MdEmail, MdPerson } from "react-icons/md";
import { useTheme } from "../../ThemeContext";

dayjs.extend(relativeTime);
const PortalUsersTabs = () => {
  const { id } = useParams();
  const [userDetails, setUserDetails] = useState([]);
  // //console.log()(userDetails, "userDetailsDash");
  const fetchUserOverview = async () => {
    try {
      const response = await fetchEntityById("getDashboard", id);

      // //console.log()(response, "fetchUserOverview");
      if (response?.data) {
        // const data = response?.data;
        // const data = response.issues.map((issue) => ({
        //   ...issue,
        //   id: issue.issue_id, // Add id field for Data Grid
        // }));

        setUserDetails(response.data);
      } else {
        console.error("No issues found in the response.");
      }
    } catch (error) {
      console.error("Error fetching issues:", error)
    }
  };

  useEffect(() => {
    fetchUserOverview();
  }, [id]);

  return (
    <div className="mt-3 ">
      <ul className="nav nav-tabs" id="myTab" role="tablist">
        <li className="nav-item pe-4" role="presentation">
          <button
            className="active text-rgba-gray R_btn"
            id="Overview-tab"
            data-bs-toggle="tab"
            data-bs-target="#Overview"
            type="button"
            role="tab"
            aria-controls="Overview"
            aria-selected="true"
          >
            Overview
          </button>
        </li>

        <li className="nav-item pe-4" role="presentation">
          <button
            className=" text-rgba-gray R_btn"
            id="Project-tab"
            data-bs-toggle="tab"
            data-bs-target="#Project"
            type="button"
            role="tab"
            aria-controls="Project"
            aria-selected="false"
          >
            Project
          </button>
        </li>

        <li className="nav-item pe-4" role="presentation">
          <button
            className="  text-rgba-gray R_btn"
            id="Task-tab"
            data-bs-toggle="tab"
            data-bs-target="#Task"
            type="button"
            role="tab"
            aria-controls="Task"
            aria-selected="false"
          >
            Task
          </button>
        </li>

        <li className="nav-item pe-4" role="presentation">
          <button
            className=" text-rgba-gray R_btn"
            id="Issues-tab"
            data-bs-toggle="tab"
            data-bs-target="#Issues"
            type="button"
            role="tab"
            aria-controls="Issues"
            aria-selected="false"
          >
            Issues
          </button>
        </li>

        <li className="nav-item pe-4" role="presentation">
          <button
            className=" text-rgba-gray R_btn"
            id="Milestone-tab"
            data-bs-toggle="tab"
            data-bs-target="#Milestone"
            type="button"
            role="tab"
            aria-controls="Milestone"
            aria-selected="false"
          >
            Milestone
          </button>
        </li>

        <li className="nav-item pe-4" role="presentation">
          <button
            className=" text-rgba-gray R_btn"
            id="Timesheet-tab"
            data-bs-toggle="tab"
            data-bs-target="#Timesheet"
            type="button"
            role="tab"
            aria-controls="Timesheet"
            aria-selected="false"
          >
            Timesheet
          </button>
        </li>

        <li className="nav-item pe-4" role="presentation">
          <button
            className=" text-rgba-gray R_btn"
            id="ActivityStream-tab"
            data-bs-toggle="tab"
            data-bs-target="#ActivityStream"
            type="button"
            role="tab"
            aria-controls="ActivityStream"
            aria-selected="false"
          >
            Activity Stream
          </button>
        </li>
      </ul>

      <div className="tab-content" id="myTabContent">
        <div
          className="tab-pane show active"
          id="Overview"
          role="tabpanel"
          aria-labelledby="Overview-tab"
        >
          <UserOverview userDetails={userDetails} />
        </div>

        <div
          className="tab-pane fade"
          id="Project"
          role="tabpanel"
          aria-labelledby="Project-tab"
        >
          <UserProject />
        </div>

        <div
          className="tab-pane fade  "
          id="Task"
          role="tabpanel"
          aria-labelledby="Task-tab"
        >
          <UserTask />
        </div>

        <div
          className="tab-pane fade"
          id="Issues"
          role="tabpanel"
          aria-labelledby="Issues-tab"
        >
          <UserIssue />
        </div>

        <div
          className="tab-pane fade"
          id="Milestone"
          role="tabpanel"
          aria-labelledby="Milestone-tab"
        >
          <UserMilestone />
        </div>

        <div
          className="tab-pane fade"
          id="Timesheet"
          role="tabpanel"
          aria-labelledby="Timesheet-tab"
        >
          <UserTimeSheetTab />
        </div>

        <div
          className="tab-pane fade"
          id="ActivityStream"
          role="tabpanel"
          aria-labelledby="ActivityStream-tab"
        >
          <UserActivity />
        </div>
      </div>
    </div>
  );
};

const PortalUsersDetail = () => {
  const { isDarkMode } = useTheme();
  const [Details, setDetails] = useState([]);
  const [headanchorEl, setheadAnchorEl] = useState(null);

  const getRelativeTime = (date) => {
    return date ? dayjs(date).fromNow() : "";
  };
  const navigate = useNavigate();
  const { id } = useParams();
  const fetchUserDetail = async () => {
    try {
      const response = await fetchEntityById("user-info", id);
      // //console.log()(response, "fetchUserres");
      if (response) {
        setDetails(response.user_info);
        // //console.log()(Details, "fetchUser");
      } else {
        console.error("No issues found in the response.");
      }
    } catch (error) {
      console.error("Error fetching issues:", error);
    }
  };
  
  useEffect(() => {
    fetchUserDetail();
  }, [id]);
  const handleBackClick = () => {
    navigate(-1); // Navigates to the previous page
  };

  const handleClick = (event) => {
    setheadAnchorEl(event.currentTarget);
  };
  const HeadhandleClose = () => {
    setheadAnchorEl(null); // Ensure this sets the anchor element to null to close the menu
  };

  const onSubmit = (data) => {
    // //console.log()(data);
  };

  return (
    <div>
      <div className={`d-flex justify-content-between align-items-center mb-3 p-3 border-bottom container-fluid rounded-bottom ${isDarkMode ? "bg-dark shadow-sm" : "bg-white"}`}
        style={{
          borderColor: isDarkMode ? "rgba(255,255,255,0.1)" : "#e0e0e0",
          borderBottom: isDarkMode ? "1px solid rgba(255,255,255,0.05)" : "1px solid #e0e0e0"
        }}
      >
        {Details ? (
          <div>
            {/* <Typography variant="h5" gutterBottom>{task.taskName}</Typography> */}

            <>
              <div className="d-flex align-items-center fw-bold" style={{ color: isDarkMode ? "#fff" : "#333", fontSize: "1.1rem" }}>
                <button className="R_btn me-2" onClick={handleBackClick} style={{ color: isDarkMode ? "#fff" : "#333" }}>
                  <IoIosArrowBack size={20} />
                </button>
                {Details.name}
              </div>
              <div className="d-flex align-items-center ps-4 mt-1">
                <div className="text-secondary small" style={{ color: isDarkMode ? "rgba(255,255,255,0.6)" : "#666" }}>{Details.email}</div>
                <div className="ms-4 small" style={{ color: isDarkMode ? "rgba(255,255,255,0.6)" : "#666" }}>
                  <span className="me-1">Role:</span>
                  <span style={{ color: isDarkMode ? "#fff" : "#333", fontWeight: "500" }}>{Details.role}</span>
                </div>
                <div className="ms-4 small" style={{ color: isDarkMode ? "rgba(255,255,255,0.6)" : "#666" }}>
                  <span className="me-1">Profile:</span>
                  <span style={{ color: isDarkMode ? "#fff" : "#333", fontWeight: "500" }}>{Details.profile}</span>
                </div>
              </div>
            </>
          </div>
        ) : (
          <Loader />
        )}

        {Details && (
          <Box
            className="d-flex align-items-center p-2 px-3"
            sx={{
              backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.05)" : "#ffffff",
              backdropFilter: isDarkMode ? "blur(10px)" : "none",
              borderRadius: "12px",
              border: isDarkMode ? "1px solid rgba(255, 255, 255, 0.1)" : "1px solid #e0e0e0",
              boxShadow: isDarkMode ? "0 4px 20px rgba(0, 0, 0, 0.4)" : "0 2px 4px rgba(0,0,0,0.02)",
              minWidth: "320px",
              transition: "all 0.3s ease",
            }}
          >
            <Box
              sx={{
                backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.12)" : "#f8f9fa",
                borderRadius: "10px",
                width: "42px",
                height: "42px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mr: 2,
                border: isDarkMode ? "1px solid rgba(255, 255, 255, 0.1)" : "1px solid #eee",
              }}
            >
              <MdPerson size={22} color={isDarkMode ? "#fff" : "#555"} />
            </Box>
            <Box className="d-flex flex-column text-start">
              {(Details.is_active != 0 || Details.status_action === "Activated") ? (
                <>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: "500",
                      lineHeight: "1.4",
                      color: isDarkMode ? "rgba(255, 255, 255, 0.6)" : "#777",
                      display: "flex",
                      alignItems: "center",
                      gap: 0.8,
                    }}
                  >
                    <MdEmail size={14} color={isDarkMode ? "rgba(255, 255, 255, 0.4)" : "#777"} />
                    Activated By: <span style={{ color: isDarkMode ? "#fff" : "#000", fontWeight: "600", marginLeft: "4px" }}>{Details.changed_by_email || " -"}</span>
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      lineHeight: "1.4",
                      color: isDarkMode ? "rgba(255, 255, 255, 0.5)" : "#888",
                      mt: 0.3,
                      display: "flex",
                      alignItems: "center",
                      gap: 0.8,
                    }}
                  >
                    <MdCalendarToday size={14} color={isDarkMode ? "rgba(255, 255, 255, 0.4)" : "#777"} />
                    Activated At: <span style={{ color: isDarkMode ? "#fff" : "#000", fontWeight: "600", marginLeft: "4px", display: "flex", alignItems: "center" }}>
                      <span>{Details.changed_at || Details.added_at || Details.created_at ? dayjs(Details.changed_at || Details.added_at || Details.created_at).format("DD/MM/YYYY - hh:mm A") : " -"}</span>
                      {(Details.changed_at || Details.added_at || Details.created_at) && (
                        <span style={{ marginLeft: "8px", fontSize: "10px", color: isDarkMode ? "rgba(255, 255, 255, 0.6)" : "#888", fontWeight: "normal", backgroundColor: isDarkMode ? "rgba(255,255,255,0.1)" : "#f0f0f0", padding: "1px 4px", borderRadius: "5px"}}>
                          {getRelativeTime(Details.changed_at || Details.added_at || Details.created_at)}
                        </span>
                      )}
                    </span>
                  </Typography>
                </>
              ) : (
                <>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: "500",
                      lineHeight: "1.4",
                      color: isDarkMode ? "rgba(255, 255, 255, 0.6)" : "#777",
                      display: "flex",
                      alignItems: "center",
                      gap: 0.8,
                    }}
                  >
                    <MdEmail size={14} color={isDarkMode ? "rgba(255, 255, 255, 0.4)" : "#777"} />
                    Deactivated By: <span style={{ color: isDarkMode ? "#fff" : "#000", fontWeight: "600", marginLeft: "4px" }}>{Details.changed_by_email || Details.changed_by_name || Details.inactivated_by || " -"}</span>
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      lineHeight: "1.4",
                      color: isDarkMode ? "rgba(255, 255, 255, 0.5)" : "#888",
                      mt: 0.3,
                      display: "flex",
                      alignItems: "center",
                      gap: 0.8,
                    }}
                  >
                    <MdCalendarToday size={14} color={isDarkMode ? "rgba(255, 255, 255, 0.4)" : "#777"} />
                    Deactivated At: <span style={{ color: isDarkMode ? "#fff" : "#000", fontWeight: "600", marginLeft: "4px", display: "flex", alignItems: "center" }}>
                      <span>{Details.changed_at || Details.inactivated_at || Details.updated_at ? dayjs(Details.changed_at || Details.inactivated_at || Details.updated_at).format("DD/MM/YYYY - hh:mm A") : " -"}</span>
                      {(Details.changed_at || Details.inactivated_at || Details.updated_at) && (
                        <span style={{ marginLeft: "8px", fontSize: "10px", color: isDarkMode ? "rgba(255, 255, 255, 0.6)" : "#888", fontWeight: "normal", backgroundColor: isDarkMode ? "rgba(255,255,255,0.1)" : "#f0f0f0", padding: "2px 6px", borderRadius: "5px" }}>
                          {getRelativeTime(Details.changed_at || Details.inactivated_at || Details.updated_at)}
                        </span>
                      )}
                    </span>
                  </Typography>
                </>
              )}
            </Box>
          </Box>
        )}
        
        {/* <div className='d-flex align-items-center'>
          <div className='ps-3'>
            <IconButton
              aria-label='more'
              aria-controls='long-menu'
              aria-haspopup='true'
              onClick={handleClick}
            >
             
              <BsThreeDots />
            </IconButton>
            <Menu
              id='long-menu'
              anchorEl={headanchorEl}
              open={Boolean(headanchorEl)}
              onClose={HeadhandleClose}
              PaperProps={{
                style: {
                  maxHeight: 48 * 4.5,
                  width: '20ch',
                },
              }}
            >
              <MenuItem>Edit</MenuItem>
              <MenuItem>Delete</MenuItem>
              <MenuItem>Clone</MenuItem>
              <MenuItem>Copy Link</MenuItem>
            </Menu>
          </div>
        </div> */}
      </div>
      <div className={`row p-3 ${isDarkMode ? "bg-dark" : "bg-white"}`}>
        <div className="col-md-12">
          <PortalUsersTabs />
        </div>
      </div>
    </div>
  );
};

export default PortalUsersDetail;
